import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { BrowsePage } from '@/features/browse/BrowsePage';
import { resolveLandingRoute } from '@/lib/auth/auth-redirect';
import { takeNext } from '@/lib/auth/next';
import { useAuth } from '@/lib/auth/useAuth';

export const Route = createFileRoute('/')({
  component: RootIndex,
});

function RootIndex() {
  const { loading, session, profile } = useAuth();
  const navigate = useNavigate();

  // CONFIRM-3: `/` is the public browse root for anon AND members — browse
  // replaces the old dashboard redirect (the subscriber dashboard now lives
  // behind the TopBar account link). The one redirect we keep is the
  // onboarding gate: a signed-in user who hasn't finished onboarding is still
  // pushed there before they can browse.
  useEffect(() => {
    if (loading) return;
    if (!session) return; // anon → browse, no redirect
    if (!profile) return; // signed in but profile still resolving — wait
    const target = resolveLandingRoute({ hasSession: true, profile });
    if (target.startsWith('/onboarding')) {
      void navigate({ to: target }); // onboarding gate; a carried next waits in storage
      return;
    }
    // Consume a next that arrived via a flow that bounced through '/' (e.g. a
    // profile that wasn't readable yet at callback time). Consume-once.
    const next = takeNext();
    if (next !== '/') void navigate({ to: next });
  }, [loading, session, profile, navigate]);

  return <BrowsePage />;
}
